export enum BeneficiaryType {
  BANESCO = '01',
  LOCAL = '02',
  SERVICE = 'PGFI',
  REGIONAL_INTERNATIONAL = '03'
}
